module.exports = __webpack_public_path__ + "img/pic-serv.cd0637e9.png";